var map = {
	"./home-v1.0": [
		"158c",
		"chunk-ccf1babe"
	],
	"./home-v1.0.vue": [
		"158c",
		"chunk-ccf1babe"
	],
	"./home-v2.0": [
		"9524",
		"chunk-deb4c4b2"
	],
	"./home-v2.0.vue": [
		"9524",
		"chunk-deb4c4b2"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2b2b";
module.exports = webpackAsyncContext;